import * as React from "react"
import { Fragment } from "react"
import {Container, Row, Col} from 'react-bootstrap';
import PropTypes from "prop-types"
import ResourceInfos from "./elements/resourceInfos"
import { GatsbyImage } from "gatsby-plugin-image"

const ResourcesIntroduction = ({classes="", title, subtitle, padding={bottom:80, top:80,left:15,right:15}, name="", resource}) => {
  return(
    <Container className={`${classes} component`} style={{padding:`${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`}}>
      {name === "Webinars" || name === "Downloads" ? 
        <Row className="align-items-center">
          <Col xs={12} lg={{span:6, offset:0}} className="justify-content-center">
            <div className="subtitle">
              <p className="bolder opacity-40">
                {subtitle}    
              </p>
            </div>
            <h1 className="">
              {title}    
            </h1>
            <ResourceInfos 
              labelName={resource.labels[0].name}
              resourceName={name}
              formattedDate={ name === 'Webinars' ? resource.webinar_date : resource.downloads_categories[0].name }
              classNames="text-left"
            />
            <p className="mt-3">
              {resource.intro_text}
            </p>
          </Col>
          <Col xs={12} lg={{span:6, offset:0}} className="justify-content-center mt-3 mt-lg-0">
              <GatsbyImage
                image={resource.featured_image.localFile.childImageSharp.gatsbyImageData}
                alt={resource.featured_image.alternativeText}
              /> 
          </Col>
        </Row>
      : 
        <Fragment>
          <Row className="intro">
            <Col xs={12} lg={{span:10, offset:1}} className="justify-content-center">
              <div className="subtitle text-center">
                <p className="text-center bolder opacity-40">
                  {subtitle}    
                </p>
              </div>
              <h1 className="text-center">
                {title}    
              </h1>
              {name === "" ? null :
                <ResourceInfos 
                  labelName={resource.labels[0].name}
                  resourceName={name}
                  timeToRead={resource.time_to_read}
                  formattedDate={ name === 'Webinars' ? resource.webinar_date_formatted : resource.published_at }
                  author={resource.author.full_name}
                />
              }
            </Col>
          </Row>
          { resource !== null && resource !== undefined ?
          <div className="text-center">
            <GatsbyImage
              image={resource.featured_image.localFile.childImageSharp.gatsbyImageData}
              alt={resource.featured_image.alternativeText}
            /> 
          </div>
          : null }
        </Fragment>
      }
    </Container>
  )
}

ResourcesIntroduction.propTypes = {
  classes: PropTypes.string,
  title: PropTypes.string,
  name: PropTypes.string,
  subtitle: PropTypes.string,
  resource: PropTypes.object,
}

export default ResourcesIntroduction